export default "__VITE_ASSET__0b8JB$po__"